import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/components/ui/Reveal";

const LOGS = [
  "[  OK  ] Mounted /dev/portfolio — read-only, curious by default",
  "[  OK  ] Started java-17.service — spring-boot runtime online",
  "[  OK  ] Reached kafka-broker:9092 — consuming events",
  "[  OK  ] Started docker.service — containers up",
  "[  OK  ] Loaded .zshrc — prompt ready",
  "[  OK  ] Connected github.com/anishravi",
  "[  OK  ] Reconciliation engine — 3-way, operational",
  "anish.dev — a developer workspace, booted.",
];

export default function BootScreen({ onDone }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const logTimer = setInterval(() => setCount((c) => Math.min(c + 1, LOGS.length)), 240);
    const doneTimer = setTimeout(onDone, 2650);
    return () => {
      clearInterval(logTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <motion.div
      data-testid="boot-screen"
      className="fixed inset-0 z-[10000] flex cursor-pointer flex-col items-center justify-center bg-[#05070c] font-mono"
      onClick={onDone}
      exit={{ opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: EASE }}
        className="mb-8 flex flex-col items-center gap-4"
      >
        <img src="/favicon.svg" alt="anish.dev logo" className="animate-floaty h-16 w-16 rounded-2xl shadow-[0_0_60px_rgba(0,122,255,0.45)]" />
        <p className="text-xs uppercase tracking-[0.3em] text-slate-500">anish.dev workspace</p>
      </motion.div>
      <div className="w-[min(560px,86vw)]">
        <div className="h-[3px] w-full overflow-hidden rounded-full bg-white/10">
          <motion.div
            className="h-full bg-gradient-to-r from-sky-400 via-sonoma to-iris"
            initial={{ width: "4%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 2.3, ease: "easeInOut" }}
          />
        </div>
        <div className="mt-5 space-y-1.5 text-[11px] leading-relaxed" data-testid="boot-log">
          {LOGS.slice(0, count).map((l, i) => (
            <motion.p key={i} initial={{ opacity: 0, x: -6 }} animate={{ opacity: 1, x: 0 }} className={l.startsWith("anish.dev") ? "text-sky-300" : "text-slate-500"}>
              {l}
            </motion.p>
          ))}
        </div>
      </div>
      <p className="mt-10 text-[10px] uppercase tracking-widest text-slate-700">click anywhere to skip</p>
    </motion.div>
  );
}
